import * as moment from 'moment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var S_permiso_primitivoComponent = /** @class */ (function () {
    function S_permiso_primitivoComponent(_formService) {
        this._formService = _formService;
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            cert_permiso: new FormControl('', Validators.required),
            fecha_permiso: new FormControl({ value: '', disabled: true }, Validators.required)
        });
        if (!JSON.parse(localStorage.getItem("s_permiso_primitivo"))) {
            localStorage.setItem("s_permiso_primitivo", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("s_permiso_primitivo"));
            this.form.controls['fecha_permiso'].setValue(this.rows[0] ? new Date(this.rows[0].fecha_permiso) : null);
            this.form.controls['cert_permiso'].setValue(this.rows[0] ? this.rows[0].cert_permiso : '');
        }
    }
    S_permiso_primitivoComponent.prototype.add_permiso = function (event, type) {
        if (event) {
            this.fecha_permiso = moment(event.value).format('DD/MM/YYYY');
        }
        else {
            var temp = JSON.parse(localStorage.getItem("s_permiso_primitivo"));
            if (temp > 0) {
                this.fecha_permiso = temp[0].fecha_permiso;
            }
            else {
                this.fecha_permiso = '';
            }
        }
        localStorage.setItem("s_permiso_primitivo", JSON.stringify([]));
        this.actualRow = localStorage.getItem("s_permiso_primitivo");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            cert_permiso: this.form.value.cert_permiso,
            fecha_permiso: this.fecha_permiso
        });
        localStorage.setItem("s_permiso_primitivo", JSON.stringify(this.rows));
        this.form.reset(); //
        //this.cip = JSON.parse(localStorage.getItem("cip"));
    };
    S_permiso_primitivoComponent.prototype.delete_permiso = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("s_permiso_primitivo", JSON.stringify(this.rows));
            }
        }
    };
    return S_permiso_primitivoComponent;
}());
export { S_permiso_primitivoComponent };
